module.exports = __webpack_public_path__ + "img/W.6e24addb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/W.svg
// module id = +ewL
// module chunks = 1